import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import AppLink from '../../../../../../routing/helpers/AppLink';

export default function InformationTab({ elementID }) {
  const { moduleBridgeHex, page, filtersHex } = useParams();
  const userBridge = useSelector(
    (state) => state?.module?.[moduleBridgeHex]?.userBridge
  );
  const actionPlanLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1?.[elementID]
  );

  return (
    <div className="container-fluid">
      {userBridge?.permissions?.level === 0 && (
        <div className="row">
          <div className="col-lg-12">
            <AppLink
              path="user_module_totalEnergiesRisk_actionPlan_edit"
              params={{
                moduleBridgeHex,
                actionPlanHex: actionPlanLevel1?.hex,
                page,
                filtersHex,
              }}
              className="btn btn-xs btn-success float-right"
            >
              Editar
            </AppLink>
          </div>
        </div>
      )}
      <div className="row mb-4">
        <div className="col-lg-6 mb-2" />
        <div className="col-lg-6 mb-2">
          <Title>{actionPlanLevel1?.code}</Title>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-2">
          <Title>Descripción</Title>
          {actionPlanLevel1?.description}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-2">
          <Title>Proceso</Title>
          {actionPlanLevel1?.process}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Subproceso</Title>
          {actionPlanLevel1?.subProcess}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-2">
          <Title>Riesgo</Title>
          {actionPlanLevel1?.riskCode}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Responsable</Title>
          {actionPlanLevel1?.responsibleName || '--'}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-2">
          <Title>Fecha de inicio</Title>
          {actionPlanLevel1?.startDateStamp || '--'}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Fecha de terminación</Title>
          {actionPlanLevel1?.endDateStamp || '--'}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Fecha de creación</Title>
          {actionPlanLevel1?.dateStamp}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Fecha última modificación</Title>
          {actionPlanLevel1?.modificationDateStamp || '--'}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-2">
          <Title>Observaciones</Title>
          {actionPlanLevel1?.observations}
        </div>
      </div>
    </div>
  );
}

const Title = styled.h3`
  font-size: 13px;
  font-weight: bold;
  margin: 0;
`;
